// How far sends are from a target, the way the target cards and the per-vertical charts both say
// it: a surplus once the target is met, otherwise the shortfall still to send. The minus is the
// typographic one (U+2212), so a shortfall doesn't read as a hyphenated range beside a number.
export function targetDelta(
  sent: number,
  target: number
): {readonly label: 'Surplus' | 'Shortfall'; readonly value: string} {
  const delta = sent - target;
  return delta >= 0
    ? {label: 'Surplus', value: `+${delta.toLocaleString()}`}
    : {label: 'Shortfall', value: `−${(-delta).toLocaleString()}`};
}
